import _ from 'underscore';
import { CWListeBriquesModel } from './cwListeBriques.model';
import { CWPaginatedCollection } from 'core/models/cwPaginated.collection';

export class CWListeBriquesColl<TModel extends CWListeBriquesModel = CWListeBriquesModel> extends CWPaginatedCollection<TModel>{

  habilitationV: string;
  habilitationG: string;
  usecase: string;

  constructor(models?: CWListeBriquesModel[], options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(models)) {
      options = models;
    }
    options = options || {};
    options.model = options.model || CWListeBriquesModel;
    super(models, options);
    //Default values from class
    this.habilitationV = "N";
    this.habilitationG = "N";
    this.usecase = "aujourdhui";
    this.url = (): string => {
      return Configuration.restRoot + "/rest/configuration/perso/brique/";
    }
    CWPaginatedCollection.prototype.initialize.call(this);
    this.paginated = false;
  }
}